// DS: i3.31
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Copy: React.FC<Props> = props => {
  return (
    <IconWrap {...props} disableDefaultColors>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M15 11a1 1 0 01-1 1H5a1 1 0 01-1-1V2a1 1 0 011-1h7.1a1 1 0 01.63.33l2.02 2.39a1 1 0 01.25.66V11zm-5-8H6v7h7V6h-2a1 1 0 01-1-1V3zM2 4h1v9h9v1a1 1 0 01-1 1H2a1 1 0 01-1-1V5a1 1 0 011-1z"
          clipRule="evenodd"
        />
      </svg>
    </IconWrap>
  );
};

Copy.displayName = 'Copy';

export default Copy;
